import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
// tslint:disable-next-line:max-line-length
import { APP_SETTINGS } from '@services';
import { UtilityService } from '../../core/services/utility/utility.service';
import { NgIf, NgFor, NgStyle } from '@angular/common';
import { SearchResultsSideBarComponent } from './search-results-side-bar/search-results-side-bar.component';
import { SearchResultsContentComponent } from './search-results-content/search-results-content.component';
import { FormsModule } from '@angular/forms';
declare var $: any;

@Component({
    selector: 'app-results',
    templateUrl: './search-results.component.html',
    styleUrls: ['./search-results.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        SearchResultsSideBarComponent,
        SearchResultsContentComponent,
        RouterLink,
        FormsModule,
        NgFor,
        NgStyle,
    ],
})
export class SearchResultsComponent implements OnInit, OnDestroy {
  public noMainGroupError: string;
  public noFromYear: string;
  public noToYear: string;
  public fromYears: number[] = [];
  public toYears: number[] = [];
  private currentYear: number;
  public search_key: string;
  public section: string;
  private subsciption: Subscription[] = [];

  @ViewChild('selectGroup')
  private elSelectMainGroup: ElementRef;
  @ViewChild('selectFrom')
  private elSelectFromYr: ElementRef;
  @ViewChild('filterModal')
  private elFilterModal: ElementRef;

  public results_count = 0;
  public resultsLimit = 0;

  public select_sortby = 'Most Relevant';
  // public select_sortby_default = true;
  public select_to_year: string;
  // public select_to_year_default = true;
  public select_from_year: string;
  // public select_from_year_default = true;
  public select_group: string;
  // public select_group_default = true;
  public series: string;
  public select_more_xs = false;
  public select_more_sm = false;
  public filter = { group: '', series: '', sort: '', from: '', to: '' };
  public mainGroupList: any[];
  public sortBy: any[];
  public screenWidth: number;

  constructor(private route: ActivatedRoute, private router: Router,
    private utilityService: UtilityService, private changeDetector: ChangeDetectorRef) {
    // this.search_key = this.route.snapshot.paramMap.get('key');
    // this.section = this.route.snapshot.paramMap.get('section');
    // this.isMoreSelected(this.section.toLowerCase());
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.search_key = this.route.snapshot.paramMap.get('key');
    this.section = this.route.snapshot.paramMap.get('section');
    this.isMoreSelected(this.section.toLowerCase());
    this.currentYear = (new Date()).getFullYear();
    for (let year: number = 1985; year < this.currentYear + 1; year++) {
      this.fromYears.push(year);
      this.toYears.push(year);
    }
    if (APP_SETTINGS.isMOTORRAD === "true") {
      this.mainGroupList = APP_SETTINGS.motorradMainGroupList;
    }
    else {
    this.mainGroupList = APP_SETTINGS.mainGroupList;
    }
     this.sortBy = [
  'Most Relevant',
  'Most Recent',
  'Ascending',
  'Descending'
];
this.router.events.subscribe(event => {
  // this.search_key = this.route.snapshot.queryParams['key'];
  this.select_sortby = 'Most Relevant';
  this.resultsLimit = 0;
  this.isMoreSelected(this.section.toLowerCase());
});

this.subsciption.push(this.utilityService.emit_search_key$.subscribe(value => {
  this.search_key = value;
  this.changeDetector.detach();
  this.changeDetector.detectChanges();
}));

this.subsciption.push(this.utilityService.emit_dropdown$.subscribe(value => {
  this.section = value.toLowerCase();
  this.changeDetector.detectChanges();
}));
  }
updateResultsLimit(limit: number) {
  this.resultsLimit = limit;
  this.changeDetector.detectChanges();
}
publishNewSortCriteria() {
  this.utilityService.passNewSortByCriteria(this.select_sortby);
  this.updateResultsLimit(0);
}

selectValue(value: string) {
  this.section = value;
  this.router.navigate(['/results', value.toLowerCase()]);
}
applyFilter() {
  let mainGroupCode = '';
  if (this.elSelectMainGroup.nativeElement.disabled) {
    if (this.filter.from || this.filter.to) {
      if (!this.filter.from) {
        this.noFromYear = 'Please select the year';
      } else if (!this.filter.to) {
        this.noToYear = 'Please select the year';
      } else {
        this.filter = {
          group: mainGroupCode,
          series: this.filter.series.trim(),
          sort: this.filter.sort,
          from: this.filter.from,
          to: this.filter.to
        };
        this.noFromYear = '';
        this.noToYear = '';
      }
    }
    if (this.filter.sort) {
      this.noFromYear = '';
      this.noToYear = '';
      this.noMainGroupError = '';
      this.filter = {
        group: mainGroupCode,
        series: this.filter.series.trim(),
        sort: this.filter.sort,
        from: this.filter.from,
        to: this.filter.to
      };
    }
  } else {
    if (this.filter.group) {
      if (this.filter.from || this.filter.to) {
        if (!this.filter.from) {
          this.noFromYear = 'Please select the year';
        } else if (!this.filter.to) {
          this.noToYear = 'Please select the year';
        } else {
          this.noFromYear = '';
          this.noToYear = '';
        }
      }
      const matchString = this.filter.group.match(/\[(.*?)\]/)[1];
      mainGroupCode = +matchString < 10 ? '0' + matchString : matchString;
      this.filter = {
        group: mainGroupCode,
        series: this.filter.series.trim(),
        sort: this.filter.sort,
        from: this.filter.from,
        to: this.filter.to
      };
      this.noMainGroupError = '';
    } else {
      this.noMainGroupError = 'Please select a Main Group to filter results';
      if (this.filter.sort) {
        this.noFromYear = '';
        this.noToYear = '';
        this.noMainGroupError = '';
        this.filter = {
          group: mainGroupCode,
          series: this.filter.series.trim(),
          sort: this.filter.sort,
          from: this.filter.from,
          to: this.filter.to
        };
      }
    }
  }
  if (!this.noFromYear && !this.noToYear && !this.noFromYear && this.hasFilter()) {
    this.utilityService.publishFilterCriteria(this.filter);
    $('#filterModal1').modal('hide');
    $('#filterModal').modal('hide');
    this.clearFilter();
  }
}
hasFilter(): boolean {
  return this.filter.group !== '' ||
    this.filter.sort !== '' ||
    this.filter.from !== '' ||
    this.filter.to !== '' ||
    this.filter.series !== '';
}

clearFilter() {
  this.filter.series = '';
  this.filter.sort = '';
  this.filter.group = '';
  this.filter.from = '';
  this.filter.to = '';
}

resultCountChange(count: number) {
  this.results_count = count;
  this.changeDetector.detectChanges();
}

removeFromFilter(filter: string) {
  // this.filter_array.splice(this.filter_array.indexOf(filter), 1);
}
// only for mobile and tablet versions
isMoreSelected(section: string) {
  if (section !== 'all' && section !== 'pbs' && section !== 'tri' && section !== 'sib') {
    this.select_more_xs = true;
  } else {
    this.select_more_xs = false;
  }
  if (section === 'te' || section === 'td' || section === 'tkr' || section === 'lgc' || section === 'ai') {
    this.select_more_sm = true;
  } else {
    this.select_more_sm = false;
  }
}
sendSelectedSectionToHeader(section: string) {
  this.utilityService.changeDropdown(section);
}

ngOnDestroy(): void {
  this.subsciption.forEach(s => s.unsubscribe());
}
}


